import React from 'react';

import { useAppConfig } from '@state';

const DEFAULT_APP_INFO = { name: 'DICOM Viewer', contact: 'support@dicomviewer.vn' };
const VERSION = process.env.VERSION_NUMBER || '0.0.0';

const AboutModal = () => {
	const [appConfig] = useAppConfig();
	const { name, contact } = appConfig.appInfo || DEFAULT_APP_INFO;
	// const version = document.querySelector('meta[name="version"]') as HTMLMetaElement;

	return (
		<div className="grid items-center gap-2 text-xs font-light">
			<div className="grid grid-cols-5  items-center">
				<div className="col-span-3">{name}</div>
			</div>
			<div className="grid grid-cols-5  items-center">
				<div className="col-span-3">{`v${VERSION}`}</div>
			</div>
			<div className="grid grid-cols-5  items-center">
				<a href={`mailto:${contact}`} className="col-span-3 text-primary-light hover:underline">
					{contact}
				</a>
			</div>
		</div>
	);
};

export default AboutModal;
